import React, { useState } from "react";
import InnoIcons from "InnoUI/innoicons";
import { Button, DetailDrawer } from "InnoUI/components";
import JournalDetails from "views/ProjectHome/Journal/JournalDetails";
import FileDetailsView from "views/ProjectHome/ListFileAndPermission/FileDetailsView";
import TimezoneConverter from "components/TimeZoneConvertor";
import theme from "theme";
import SC from "../style";
import CartHistoryDetailsShimmer from "./CartHistoryDetailsShimmer";
import EmailDetailsTooltip from "components/EmailDetailsTooltip";

const CartHistoryDetails = ({
  historyData,
  sendTypeLabel = {},
  onClose,
  loading = false,
}) => {
  const [openJournalDetails, setOpenJournalDetails] = useState(false);
  const [openFileDetails, setOpenFileDetails] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState(null);
  const [hoveredFileId, setHoveredFileId] = useState(null);
  const occupants = historyData?.occupants || [];
  const occupantIds = historyData?.occupantIds || [];

  const renderRecipientValue = (users = [], fallback = "") => {
    if (users.length > 0) {
      return (
        <EmailDetailsTooltip
          data={users}
          maxWidth={"500px"}
          fontSize={"12px"}
          opacity={"0.6"}
        />
      );
    }

    return fallback || "--";
  };

  const renderDetailRow = (icon, label, value, isLast = false) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "160px 1fr",
        alignItems: "center",
        fontSize: "13px",
        padding: "11px 14px",
        borderBottom: isLast ? "none" : `1px solid ${theme.colors.bordertask}`,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#999",
        }}
      >
        {icon}
        <span>{label}</span>
      </div>
      <span style={{ fontWeight: 600, color: "#222" }}>{value || "--"}</span>
    </div>
  );

  const handleOpenFileDetails = (e, file) => {
    e.stopPropagation();
    const fileId = file?.currentFile?.id || file.fileId;
    setSelectedFileData({ id: fileId });
    setOpenFileDetails(true);
  };

  if (!historyData) return null;

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>Cart History Details</SC.DrawerTitles>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            caption="View Journal Details"
            color="white"
            fontSize="12px"
            onClick={() => setOpenJournalDetails(true)}
            style={{
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "120px",
              height: "30px",
              borderRadius: "5px",
              border: `1px solid ${theme.colors.white}`,
            }}
            disabled={!historyData.journalId}
          />
          <SC.CloseIcon>
            <InnoIcons.CloseIcon onClick={onClose} />
          </SC.CloseIcon>
        </div>
      </SC.DrawerTitlesContainer>

      {loading && <CartHistoryDetailsShimmer />}

      {!loading && (
        <div style={{ padding: "14px 20px" }}>
          <div
            style={{
              fontSize: "13px",
              fontWeight: 700,
              letterSpacing: "0.5px",
              color: "#555",
              marginBottom: "10px",
            }}
          >
            MESSAGE DETAILS
          </div>
          <div
            style={{
              border: `1px solid ${theme.colors.bordertask}`,
              borderRadius: "8px",
              overflow: "hidden",
              marginBottom: "20px",
            }}
          >
            {renderDetailRow(
              <InnoIcons.TagIcon style={{ fontSize: "15px" }} />,
              "Journal-Subject",
              historyData.journalSubject,
            )}
            {renderDetailRow(
              <InnoIcons.UserOutlined style={{ fontSize: "15px" }} />,
              "Sender",
              historyData.senderName || historyData.senderEmail,
            )}
            {renderDetailRow(
              <InnoIcons.FileDownloadOutlinedIcon
                style={{ fontSize: "15px" }}
              />,
              "Send Type",
              sendTypeLabel[historyData.sendType],
            )}
            {renderDetailRow(
              <InnoIcons.EmailIcon style={{ fontSize: "15px" }} />,
              "Send To",
              renderRecipientValue(
                historyData.sendToWithName,
                historyData.sendTo,
              ),
            )}
            {renderDetailRow(
              <InnoIcons.PersonRoundedIcon style={{ fontSize: "15px" }} />,
              "Send Cc",
              renderRecipientValue(
                historyData.sendCcWithName,
                historyData.sendCc,
              ),
            )}
            {renderDetailRow(
              <InnoIcons.PersonRoundedIcon style={{ fontSize: "15px" }} />,
              "Send Bcc",
              renderRecipientValue(
                historyData.sendBccWithName,
                historyData.sendBcc,
              ),
              true,
            )}
          </div>

          <div style={{ marginTop: "18px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                  color: "#555",
                }}
              >
                LINKED OCCUPANTS
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  padding: "1px 8px",
                  borderRadius: "10px",
                  background: "#e8e8e8",
                  color: "#555",
                }}
              >
                {occupants.length || occupantIds.length}
              </span>
            </div>
            {occupants.length === 0 && occupantIds.length === 0 ? (
              <div style={{ fontSize: "12px", opacity: 0.7 }}>
                No occupant selected.
              </div>
            ) : occupants.length > 0 ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "8px",
                }}
              >
                {occupants.map((occupant) => (
                  <div
                    key={occupant.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 14px",
                      border: `1px solid ${theme.colors.bordertask}`,
                      borderRadius: "8px",
                      fontSize: "13px",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {occupant.occupantName || "--"}
                    </span>
                    <span
                      style={{
                        fontSize: "11px",
                        padding: "3px 8px",
                        borderRadius: "6px",
                        background: "#e8e8e8",
                        color: "#444",
                        fontWeight: 500,
                        flexShrink: 0,
                        marginLeft: "6px",
                      }}
                    >
                      {occupant.occupantNo || occupant.id}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "8px",
                }}
              >
                {occupantIds.map((occupantId) => (
                  <div
                    key={occupantId}
                    style={{
                      padding: "12px 14px",
                      border: `1px solid ${theme.colors.bordertask}`,
                      borderRadius: "8px",
                      fontSize: "13px",
                      fontWeight: 600,
                    }}
                  >
                    {occupantId}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ marginTop: "18px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                  color: "#555",
                }}
              >
                FILES
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  padding: "1px 8px",
                  borderRadius: "10px",
                  background: "#e8e8e8",
                  color: "#555",
                }}
              >
                {(historyData.files || []).length}
              </span>
            </div>
            {(historyData.files || []).length === 0 ? (
              <div style={{ fontSize: "12px", opacity: 0.7 }}>
                No files found.
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "8px",
                }}
              >
                {(historyData.files || []).map((file) => {
                  const isHovered = hoveredFileId === file.fileId;
                  return (
                    <div
                      key={file.fileId}
                      onMouseEnter={() => setHoveredFileId(file.fileId)}
                      onMouseLeave={() => setHoveredFileId(null)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 14px",
                        border: `1px solid ${isHovered ? theme.colors.themeColor : theme.colors.bordertask}`,
                        borderRadius: "8px",
                        background: "#fff",
                        transition: "border-color 0.2s",
                        overflow: "hidden", // ADD THIS
                        width: "100%", // ADD THIS
                      }}
                    >
                      <InnoIcons.InsertDriveFileIcon
                        style={{
                          fontSize: "18px",
                          color: "#666",
                          flexShrink: 0,
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "2px",
                          flex: 1,
                          minWidth: 0, // Important
                          overflow: "hidden",
                        }}
                      >
                        {file.subject && (
                          <span
                            style={{
                              display: "block", // Important
                              width: "100%",
                              fontSize: "12px",
                              fontWeight: 600,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              color: isHovered
                                ? theme.colors.themeColor
                                : "#222",
                              transition: "color 0.2s",
                            }}
                            title={file.subject}
                          >
                            {file.subject}
                          </span>
                        )}

                        <span
                          style={{
                            display: "block",
                            width: "100%",
                            fontSize: "11px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            color: isHovered ? theme.colors.themeColor : "#666",
                            transition: "color 0.2s",
                          }}
                          title={file.fileName || file.fileId}
                        >
                          {file.fileName || file.fileId}
                        </span>
                      </div>
                      {file.deleted ? (
                        <span
                          style={{
                            color: "#f05455",
                            fontSize: "11px",
                            flexShrink: 0,
                          }}
                        >
                          File is deleted
                        </span>
                      ) : (
                        <button
                          onClick={(e) => handleOpenFileDetails(e, file)}
                          style={{
                            fontSize: "11px",
                            padding: "3px 10px",
                            border: `1px solid ${theme.colors.themeColor}`,
                            borderRadius: "4px",
                            background: "#fff",
                            cursor: "pointer",
                            color: theme.colors.themeColor,
                            flexShrink: 0,
                          }}
                        >
                          View Details
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <div style={{ marginTop: "18px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                  color: "#555",
                }}
              >
                DOWNLOAD HISTORY
              </span>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  padding: "1px 8px",
                  borderRadius: "10px",
                  background: "#e8e8e8",
                  color: "#555",
                }}
              >
                {(historyData.accessHistory || []).length}
              </span>
            </div>
            {(historyData.accessHistory || []).length === 0 ? (
              <div style={{ fontSize: "12px", opacity: 0.7 }}>
                No download history yet.
              </div>
            ) : (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                {(historyData.accessHistory || []).map((access) => (
                  <div
                    key={access.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      padding: "10px 14px",
                      border: `1px solid ${theme.colors.bordertask}`,
                      borderRadius: "8px",
                      background: "#fff",
                    }}
                  >
                    <div
                      style={{
                        width: "34px",
                        height: "34px",
                        borderRadius: "50%",
                        background: "#f5a623",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <InnoIcons.PersonRoundedIcon
                        style={{ fontSize: "20px", color: "#fff" }}
                      />
                    </div>

                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#333",
                        }}
                      >
                        {access.name || access.userName || "Unknown User"}
                      </span>

                      {access.userEmail && (
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#666",
                          }}
                        >
                          {access.userEmail}
                        </span>
                      )}

                      {access.companyName && (
                        <span
                          style={{
                            fontSize: "11px",
                            color: "#888",
                          }}
                        >
                          {access.companyName}
                        </span>
                      )}
                    </div>
                    <span
                      style={{
                        fontSize: "11px",
                        padding: "2px 10px",
                        borderRadius: "12px",
                        background: "#e8e8e8",
                        color: "#555",
                        flexShrink: 0,
                      }}
                    >
                      {access.accessType || "downloaded"}
                    </span>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        fontSize: "12px",
                        color: "#555",
                        flexShrink: 0,
                      }}
                    >
                      <InnoIcons.ClockCircleOutlined
                        style={{ fontSize: "13px" }}
                      />
                      <TimezoneConverter time={access.accessedOn} />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {openJournalDetails && (
        <DetailDrawer
          open={openJournalDetails}
          onClose={() => setOpenJournalDetails(false)}
          title={false}
          closable={true}
          width="970px"
          children={
            <JournalDetails
              onClose={() => setOpenJournalDetails(false)}
              selectedRowId={historyData.journalId}
            />
          }
        />
      )}

      {openFileDetails && selectedFileData && (
        <DetailDrawer
          open={openFileDetails}
          onClose={() => setOpenFileDetails(false)}
          title={false}
          closable={true}
          width="970px"
          children={
            <FileDetailsView
              isDrawer={true}
              fileData={selectedFileData}
              onClose={() => setOpenFileDetails(false)}
            />
          }
        />
      )}
    </>
  );
};

export default CartHistoryDetails;
